/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

export const Mouth = ({ opacity = "0.7", className }) => {
  return (
    <svg
      className={`mouth ${className}`}
      fill="none"
      height="7"
      viewBox="0 0 17 7"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        clipRule="evenodd"
        d="M5.30371 2.45312C5.30371 3.66815 6.80966 4.65312 8.66735 4.65312C10.525 4.65312 12.031 3.66815 12.031 2.45312"
        fill="black"
        fillOpacity={opacity}
        fillRule="evenodd"
      />
    </svg>
  );
};

Mouth.propTypes = {
  opacity: PropTypes.string,
};
